export const basePath = window.location.pathname.startsWith('/public-preview') ? '/public-preview' : '';

export function asset(path: string): string {
  return `${basePath}${path}`;
}
